module.exports = __webpack_public_path__ + "img/主数据服务select.90a76e98.svg";